import React, { useEffect } from "react";

const AppRedirect = () => {
	useEffect(() => {
		// Redirect to Play Store
		const link = "https://play.google.com/store/apps/details?id=com.dproz.app";

		const a = document.createElement("a");
		a.href = link;
		a.target = "_blank";
		a.rel = "noopener noreferrer";
		a.click();
	}, []);

	return (
		<div className="flex items-center justify-center min-h-screen bg-gray-50">
			<div className="text-center">
				<div className="mb-4">
					<div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600" />
				</div>
				<p className="text-gray-600 font-inter">Redirecting to Google Play Store...</p>
			</div>
		</div>
	);
};

export default AppRedirect;
